const img1 = require('./insta1.png');
const img2 = require('./insta2.png');
const img3 = require('./insta3.png');
const img4 = require('./insta4.png');

export const fotosInsta = [img1, img2, img3, img4];
